export enum ConversationEvent {
  conversationJoined = "conversationJoined"
}
